import Utils from './utils';


export default class Entity {
	
	/**
	 * Fundamental game object, owned by a Scene, optionally contains a Sprite and/or a Brain.
	 * @param {Object} args
	 * @param {String} args.name optional (internal object name)
	 * @param {*} args.scene host Scene
	 * @param {*} args.sprite optional
	 * @param {*} args.brain optional
	 * @param {Number} args.bitgroup collision bitgroup, defaults to 0x00000000
	 */
	constructor(args) {
		this.name = args.name || 'entity';
		this.uid = this.name+'_'+Utils.getUID();
		this.scene = args.scene;
		this.system = args.scene.system;
		this.destroyed = false;

		// visual presentation (pixi display object / matter physics body)
		this.sprite = args.sprite || null;
		
		// animation, interactivity, game logic, AI, etc.
		this.brain = args.brain || null;

		// collision group
		this.bitgroup = args.bitgroup || 0x00000000;
	}
	
	init() {
		if(this.sprite) {
			this.sprite.init(this);
			this.sprite.update(0, 0);
		}
		if(this.brain) {
			this.brain.init(this);
			this.brain.update(0, 0);
		}
	}

	update(delta, deltaNormal) {
		if(!this.destroyed) {
			if(this.brain) this.brain.update(delta, deltaNormal);
			if(this.sprite) this.sprite.update(delta, deltaNormal);
		}
	}

	destroy() {
		this.destroyed = true;
		if(this.sprite) this.sprite.hide();
	}
	
	destroyNow() {
		if(this.brain) this.brain.destroy();
		this.brain = null;
		if(this.sprite) this.sprite.destroy();
		this.sprite = null;
	}

}